import { Component, OnInit, Input } from '@angular/core';
// import { Subscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';

import { AuthService } from './auth.service';
import { ApplicantService } from './applicant.service';
import {
  NAVIGATION_RETAIL, NAVIGATION_RETAIL_AP, NAVIGATION_RETAIL_CO, NAVIGATION_RETAIL_MP, SEND_TO_CBS_MENU
} from './navigation';
import { environment as ENV } from 'environments/environment';


import { Compiler } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OpenDialog } from './dialog-for-cbs/dialog.component';
import { CibilReportService } from './financial/cibil-report/cibil-report.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';


@Component({
  selector: 'wl-laas',
  templateUrl: './laas.component.html',
  styleUrls: ['./laas.component.scss'],
  providers: [CibilReportService]
})
export class LaasComponent implements OnInit {

  // watcher: Subscription;
  activeMediaQuery = '';
  sideNav = { mode: 'side', isOpened: true };
  navList: any;
  profile: any;
  demo: any;
  shwHideLogOut: boolean = true;


  @Input() profileImg: any;
  role: string;
  roleId: string;
  showSpinner: boolean;
  breFailure: boolean;

  constructor(

    private router: Router,
    private auth: AuthService,
    private applicant: ApplicantService,
    private dialog: MatDialog,
    private crifReport: CibilReportService,
    private breakpointObserver: BreakpointObserver,
  ) {
    // Identify if screen size is unsuitable to display sidenav side-by-side.
    //
    // This was commented out because it used ObservableMedia from
    // @angular/flex-layout, which was dropped in the Angular 15 -> 16 upgrade.
    // While it was dead the sidenav stayed mode:'side' + opened, so on a phone a
    // 250px drawer permanently pushed the content off-screen. Reinstated using
    // the CDK's BreakpointObserver, which is what AdminComponent already uses.
    this.breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
    ]).subscribe(result => {
      this.sideNav = result.matches
        ? { mode: 'push', isOpened: false }
        : { mode: 'side', isOpened: true };
    });

    // this.navList = NAVIGATION_CAN;
    this.demo = ENV.placeHolderSetting.demo;
    this.shwHideLogOut = false;

  }

  ngOnInit() {

    console.log('-----------------', sessionStorage.getItem('lrOpenedFromAdmin'));
    if (sessionStorage.getItem('lrOpenedFromAdmin') == 'false') {
      this.sideNav.isOpened = false
      sessionStorage.setItem('lrOpenedFromAdmin', 'true')

    }

    this.applicant.getCbsStatus().subscribe(resp => {
      console.log(resp, "resp from laas auth guard")
      if (resp && resp.success) {
        if ((resp && resp.result && resp.result[ENV.cbsStatusFormat]) || (resp && resp.result && resp.result.sent_to_cbs_date && resp.result.sent_to_cbs) || (resp && resp.result && resp.result.sent_to_cbs_id)) {

          this.router.navigate(['/laas/applications/loan-renewal-form'])
          const dialogRef = this.dialog.open(OpenDialog, {
            width: 'auto', height: 'auto',
            data: { heading: "Application Already Sent to CBS", content: "" }
          });
        }
      }
    })

    this.role = sessionStorage.getItem('wzbvdsjvbbs');
    console.log("role " + this.role);

    this.roleId = sessionStorage.getItem('getroleId');

    this.applicant.getCbsStatus().subscribe(resp => {
      console.log(resp, "resp from 95")
      // if (resp && resp.success) {
      // this.changeColor(0)
      if ((resp && resp.result && resp.result[ENV.cbsStatusFormat]) || (resp && resp.result && resp.result.sent_to_cbs_date) || (resp && resp.result && resp.result.sent_to_cbs_id)) {
        this.navList = SEND_TO_CBS_MENU;
      } else {


        if (this.roleId == "4") {
          this.navList = NAVIGATION_RETAIL_CO;
        } else if (this.roleId == "5") {
          this.navList = NAVIGATION_RETAIL;//NAVIGATION_KCC_CO
        } else {
          this.navList = NAVIGATION_RETAIL;
        }

        // }        
        let stateCode = sessionStorage.getItem('wEnlw3OeU3')
        if (stateCode == "KDw2nS6vb5cJ286KJ3JwtGKGnnnLO93Y") {
          if (this.roleId == "4") {
            this.navList = NAVIGATION_RETAIL_CO;
          } else if (this.roleId == "5") {
            this.navList = NAVIGATION_RETAIL;//NAVIGATION_KCC_CO
          } else {
            this.navList = NAVIGATION_RETAIL;
          }
        } else if (stateCode == "xmpHUKBVNVSFG61XnJAzKOQ32EWjSdE1") {
          if (this.roleId == "4") {
            this.navList = NAVIGATION_RETAIL_CO;
          } else if (this.roleId == "5") {
            this.navList = NAVIGATION_RETAIL_MP;//NAVIGATION_KCC_CO
          } else {
            this.navList = NAVIGATION_RETAIL_MP;
          }
        }else if (stateCode == "X0ZUk5Z7otQSnJFm9rc2bcAvwPrp66i6") {
          if (this.roleId == "4") {
            this.navList = NAVIGATION_RETAIL_CO;
          } else if (this.roleId == "5") {
            this.navList = NAVIGATION_RETAIL_AP;//NAVIGATION_KCC_CO
          } else {
            this.navList = NAVIGATION_RETAIL_AP;
          }
        }
      }
    })

    this.applicant.getProfile().subscribe(profile => {
      this.profile = profile;
      console.log("Profile ", profile);
    });


  }

  toggleSubmenu(menuItem) {
    menuItem.isSubmenuVisible = !menuItem.isSubmenuVisible;
    if (menuItem.link) {
      this.router.navigate([menuItem.link]);
    }
  }

  logout() {
    this.auth.logout();
    this.router.navigate(['/login']);
  }

  changeColor(i) {
    for (let i = 0; i < this.navList.length; i++) {
      this.navList[i].isSelected = false
    }
    for (let i = 0; i < this.navList.length; i++) {
      if (this.navList && this.navList[i] && this.navList[i].submenu) {
        for (let m = 0; m < this.navList[i].submenu.length; m++) {
          this.navList[i].submenu[m].isSubMenuSelected = false
        }
      }

    }
    this.navList[i].isSelected = true
  }

  changeColorSubMenu(k, j) {
    for (let i = 0; i < this.navList.length; i++) {
      this.navList[i].isSelected = false
    }
    for (let i = 0; i < this.navList.length; i++) {
      if (this.navList && this.navList[i] && this.navList[i].submenu) {
        for (let m = 0; m < this.navList[i].submenu.length; m++) {
          console.log(this.navList[i].submenu[m])
          this.navList[i].submenu[m].isSubMenuSelected = false
        }
      }

    }
    console.log(this.navList[k].submenu[j])
    this.navList[k].submenu[j].isSubMenuSelected = true
  }

}
